import { chain } from "lodash";
import { StorageSubscriptionManager } from "../subscriptions";
const defaultGetByHandlePrefixOptions = {
    limit: 5,
};
const MinCharactersForUserSearch = 3;
const OverFetchFludgeFactorForFilteredUserSearch = 10;
export class BaseUserRepository {
    subscriptionMgrByUid = new StorageSubscriptionManager();
    subscriptionMgrByHandle = new StorageSubscriptionManager();
    /** @inheritDoc */
    subscribeToUser(uid, onChange) {
        return this.subscriptionMgrByUid.addSubscription(uid, onChange);
    }
    /** @inheritDoc */
    subscribeToUserHandle(handle, onChange) {
        return this.subscriptionMgrByHandle.addSubscription(handle, onChange);
    }
    /** @inheritDoc */
    async getFilteredByHandlePrefix(handlePrefix, options) {
        const { limit } = { ...defaultGetByHandlePrefixOptions, ...(options ?? {}) };
        const minChars = options?.minCharacters ?? MinCharactersForUserSearch;
        if (handlePrefix.length < minChars) {
            // NOTE: Not sure what the limit is on the create side
            return [];
        }
        // NOTE: overfetch the limit here to allow for sorting and filtering test users
        const userDatas = await this.getByHandlePrefix(handlePrefix, {
            ...options,
            limit: limit * OverFetchFludgeFactorForFilteredUserSearch,
        });
        return (chain(userDatas)
            .filter((user) => user.sign_up_referrer !== "rainforrest_tester")
            // NOTE: it is not clear when exactly most of these timestamps
            // are supposed to be set or whether they are actually
            // working, so here we defensively use all of them in order
            // from best to worst.
            // TODO: fix https://github.com/buildwithflux/flux-app/issues/6649
            .sortBy((user) => {
            // Exact match should always be first
            if (user.handle === handlePrefix || user.email === handlePrefix) {
                return Number.MAX_SAFE_INTEGER;
            }
            return user.last_active_at || user.last_sign_in_at || user.updated_at || user.created_at;
        })
            .reverse()
            .take(limit)
            .value());
    }
}
//# sourceMappingURL=BaseUserRepository.js.map